export const AFTER_AUTH_REDIRECT_TO = "AFTER_AUTH_REDIRECT_TO";
export const MCP_NEXT_URL = "mcp_next_url";
export const ENTITY_CREATION_TIMESTAMP = "entity_creation_timestamp";
export const AUTH_TOKENS = "authTokens";
export const CURRENT_USER = "currentUser";
export const REFERRAL_CODE = "referralCode";
export const WEBAUTHN_PROMPT_PENDING = "webauthnPromptPending";
export const GOOGLE_TOS_ACCEPTED = "googleTosAccepted";
export const FINALLY_MIGRATION_BANNER_DISMISSED_KEY =
  "finally_migration_banner_dismissed";
